<template>
	<div>
		<info-paciente
			:datosPaciente="datosPaciente"
			style="margin-bottom: 10px"
		></info-paciente>
		<v-stepper vertical v-model="pasoActual">
			<v-stepper-step
				step="1"
				:complete="completado(1)"
				:editable="puedeEditar(1)"
			>
				Antecedentes heredofamiliares
			</v-stepper-step>
			<v-stepper-content step="1">
				<antecedentes-heredofamiliares
					:datos="datosPasos.AntecedentesHeredofamiliares"
					@siguiente="siguiente"
				></antecedentes-heredofamiliares>
			</v-stepper-content>
			<v-stepper-step
				step="2"
				:complete="completado(2)"
				:editable="puedeEditar(2)"
			>
				Antecedentes personales no patológicos
			</v-stepper-step>
			<v-stepper-content step="2">
				<ant-no-patologicos
					:datos="datosPasos.AntecedentesNoPatologicos"
					@anterior="anterior"
					@siguiente="siguiente"
				></ant-no-patologicos>
			</v-stepper-content>
			<v-stepper-step
				step="3"
				:complete="completado(3)"
				:editable="puedeEditar(3)"
			>
				Antecedentes personales patológicos y farmacoterapia
			</v-stepper-step>
			<v-stepper-content step="3">
				<ant-per-pat-far
					:datos="
						datosPasos.AntecedentesPatologicos
							? JSON.parse(datosPasos.AntecedentesPatologicos)
							: null
					"
					@siguiente="siguiente"
					@anterior="anterior"
				></ant-per-pat-far>
			</v-stepper-content>
			<v-stepper-step
				step="4"
				:complete="completado(4)"
				:editable="puedeEditar(4)"
			>
				Terapia de Reemplazo Renal
			</v-stepper-step>
			<v-stepper-content step="4">
				<terapia-reemplazo-renal
					:datos="
						datosPasos.TerapiaRenal
							? JSON.parse(datosPasos.TerapiaRenal)
							: null
					"
					@siguiente="siguiente"
					@anterior="anterior"
				></terapia-reemplazo-renal>
			</v-stepper-content>
			<v-stepper-step
				step="5"
				:complete="completado(5)"
				:editable="puedeEditar(5)"
			>
				Evaluación Antropométrica
			</v-stepper-step>
			<v-stepper-content step="5">
				<evaluacion-antropometrica
					:datos="datosPasos.EvaluacionAntropometrica"
					@siguiente="siguiente"
					@anterior="anterior"
				></evaluacion-antropometrica>
			</v-stepper-content>
			<v-stepper-step
				step="6"
				:complete="completado(6)"
				:editable="puedeEditar(6)"
			>
				Resultados De Bioimpedancia Eléctrica Y Plicometría
			</v-stepper-step>
			<v-stepper-content step="6">
				<resultados-bioimp
					:esHombre="esHombre"
					:edad="edad"
					:datos="datosPasos.ResultadosBioimpedancia"
					@siguiente="siguiente"
					@anterior="anterior"
				></resultados-bioimp>
			</v-stepper-content>
			<v-stepper-step
				step="7"
				:complete="completado(7)"
				:editable="puedeEditar(7)"
			>
				Evaluación Bioquímica
			</v-stepper-step>
			<v-stepper-content step="7">
				<evaluacion-bioquimica
					:datos="datosPasos.EvaluacionBioquimica"
					@siguiente="siguiente"
					@anterior="anterior"
				></evaluacion-bioquimica>
			</v-stepper-content>
			<v-stepper-step
				step="8"
				:complete="completado(8)"
				:editable="puedeEditar(8)"
			>
				Evaluación Clínica
			</v-stepper-step>
			<v-stepper-content step="8">
				<v-card-text class="v-title">EXPLORACIÓN FÍSICA</v-card-text>
				<exploracion-fisica
					:datos="
						datosPasos.ExploracionFisica
							? JSON.parse(datosPasos.ExploracionFisica)
							: null
					"
					@siguiente="siguiente"
					@anterior="anterior"
				></exploracion-fisica>
			</v-stepper-content>
			<v-stepper-step
				step="9"
				:complete="completado(9)"
				:editable="puedeEditar(9)"
			>
				Valoración Global Subjetiva (VGS)
			</v-stepper-step>
			<v-stepper-content step="9">
				<valoracion-global-subjetiva
					:datos="
						datosPasos.ValoracionGlobal
							? JSON.parse(datosPasos.ValoracionGlobal)
							: null
					"
					@siguiente="siguiente"
					@anterior="anterior"
				></valoracion-global-subjetiva>
			</v-stepper-content>
			<v-stepper-step
				step="10"
				:complete="completado(10)"
				:editable="puedeEditar(10)"
			>
				Evaluación Dietética
			</v-stepper-step>
			<v-stepper-content step="10">
				<recordatorios
					:datos="datosPasos.EvaluacionDietetica"
					@siguiente="siguiente"
					@anterior="anterior"
				></recordatorios>
			</v-stepper-content>
			<v-stepper-step
				step="11"
				:complete="completado(11)"
				:editable="puedeEditar(11)"
			>
				Diagnóstico Nutricional
			</v-stepper-step>
			<v-stepper-content step="11">
				<diagnostico-nutricional
					:datos="datosPasos.DiagnosticoNutricional"
					@siguiente="siguiente"
					@anterior="anterior"
				></diagnostico-nutricional>
			</v-stepper-content>
			<v-stepper-step
				step="12"
				:complete="completado(12)"
				:editable="puedeEditar(12)"
			>
				Plan Terapéutico
			</v-stepper-step>
			<v-stepper-content step="12">
				<v-card-text class="v-title">PLAN TERAPÉUTICO</v-card-text>
				<plan-terapeutico-info
					:esHombre="esHombre"
					:datos="datosPasos.PlanTerapeutico"
					:edad="datosPaciente.Edad"
					:datosAntropometricos="datosAntropometricos"
				></plan-terapeutico-info>
				<template v-if="false">
					<v-card-text class="v-title"
						>CÁLCULO DE EQUIVALENTES</v-card-text
					>
					<calculo-equivalentes></calculo-equivalentes>
				</template>
			</v-stepper-content>
		</v-stepper>
	</div>
</template>

<script>
import EvaluacionAntropometrica from "./EvaluacionAntropometrica.vue";
import AntecedentesHeredofamiliares from "./AntecedentesHeredofamiliares.vue";
import AntNoPatologicos from "./AntNoPatologicos.vue";
import AntPerPatFar from "./AntPerPatFar.vue";
import TerapiaReemplazoRenal from "./TerapiaReemplazoRenal.vue";
import resultadosBioimp from "./resultadosBioimp.vue";
import evaluacionBioquimica from "./evaluacionBioquimica.vue";
import exploracionFisica from "./exploracionFisica.vue";

import recordatorios from "./recordatorios.vue";
import ValoracionGlobalSubjetiva from "./ValoracionGlobalSubjetiva.vue";
import infoPaciente from "./infoPaciente.vue";
import diagnosticoNutricional from "./diagnosticoNutricional.vue";
import planTerapeuticoInfo from "./planTerapeuticoInfo.vue";

import calculoEquivalentes from "./calculoEquivalentes.vue";
import ServicioHistorialClinico from "../../../services/historialClinico";
export default {
	components: {
		EvaluacionAntropometrica,
		AntecedentesHeredofamiliares,
		AntNoPatologicos,
		AntPerPatFar,
		TerapiaReemplazoRenal,
		resultadosBioimp,
		evaluacionBioquimica,
		exploracionFisica,
		recordatorios,
		ValoracionGlobalSubjetiva,

		infoPaciente,
		diagnosticoNutricional,
		planTerapeuticoInfo,

		calculoEquivalentes
	},
	name: "pagHistorialClinico",
	data() {
		return {
			pasoActual: 1,
			datosPaciente: {},
			datosPasos: {},
			datosAntropometricos: {}
		};
	},
	methods: {
		siguiente(datos) {
			this.pasoActual++;
			// todo: mejorar
			if (datos) {
				this.datosAntropometricos = datos;
			}
		},
		anterior() {
			this.pasoActual--;
		},
		async cargarDatos() {
			const historiaClinicaId = this.$route.params.historiaClinicaId;
			const res = await ServicioHistorialClinico.getDatosHistorial(
				historiaClinicaId
			);
			this.datosPaciente = res.data.data.Table0[0];
			this.datosPasos = res.data.data.Table1[0];
			if (this.datosPasos.PasoActual) {
				this.pasoActual = this.datosPasos.PasoActual;
			}
			if (this.datosPasos.EvaluacionAntropometrica) {
				this.datosAntropometricos = JSON.parse(
					this.datosPasos.EvaluacionAntropometrica
				);
			}
		},
		puedeEditar(paso) {
			return paso < this.pasoActual || !!this.datosPasos.completado;
		},
		completado(paso) {
			return paso < this.pasoActual || !!this.datosPasos.completado;
		}
	},
	async mounted() {
		await this.cargarDatos();
	},
	computed: {
		esHombre() {
			return this.datosPaciente.SexoCDID === 40;
		},
		edad() {
			return this.datosPaciente.Edad;
		}
	}
};
</script>

<style>
.title {
	color: #1c62ad;
	font-size: 30px;
	font-weight: 400;
}
</style>
